// extracted by mini-css-extract-plugin
export default {"wrapper":"Gallery_wrapper__kHYDF","container":"Gallery_container__Hb85d","buttonWrapper":"Gallery_buttonWrapper__GzkVv","disabled":"Gallery_disabled__nyRpZ"};